// Carroussel.jsx
import React from 'react';
import Slider from 'react-slick';
import { Card, CardContent, CardMedia, Typography, Box } from '@mui/material';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carroussel = ({ cardsData, height }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Box sx={{ maxWidth: '100%', padding: 4 }}>
      <Slider {...settings}>
        {cardsData.map((card) => (
          <Box onClick={() => card.onClick && card.onClick()} key={card.id} sx={{ padding: 1 }}>
            <Card sx={{ maxWidth: 345, margin: 'auto'  }}>
              <CardMedia
                component="img"
                image={card.image}
                alt={card.title}
                sx={{ height: height || '100%', mr: 2 }}
              />
              {card.title && (
                <h6 style={{ textAlign: 'center', padding: 4, margin: 0 }}>{card.title}</h6>
              )}

              {card.description && (
                <CardContent>
                  <Typography variant="body2" color="text.secondary">
                    {card.description}
                  </Typography>
                </CardContent>
              )}
            </Card>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default Carroussel;
